// // src/reports/ComparativaTotalesChart.js
// import React, { useState } from "react";
// import {
//   LineChart,
//   Line,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   Legend,
//   ResponsiveContainer,
// } from "recharts";
// import "./ComparativaTotales.css";

// const colors = [
//   "#8884d8",
//   "#82ca9d",
//   "#ff7300",
//   "#ff0000",
//   "#0088FE",
//   "#00C49F",
//   "#FFBB28",
//   "#FF8042",
// ];

// const ComparativaTotalesChart = ({ data }) => {
//   // --- Hook siempre inicializado ---
//   const [visibleCategories, setVisibleCategories] = useState([]);

//   if (!data || !data.movimientos || !data.categorias || !data.presupuestos) {
//     return <p>No hay datos suficientes para mostrar la gráfica.</p>;
//   }

//   const { movimientos, categorias, presupuestos } = data;

//   // --- Crear mapa de categorías padre ---
//   const subArrPadres = {};
//   categorias
//     .filter((cat) => !cat.idPadre)
//     .forEach((cat) => {
//       subArrPadres[cat.id] = { categoria: cat.nombre };
//     });

//   // Inicializar visibleCategories la primera vez
//   if (visibleCategories.length === 0) {
//     setVisibleCategories(Object.keys(subArrPadres));
//   }

//   // --- Agrupar movimientos por mes y categoría padre ---
//   const gastos = {};
//   movimientos.forEach((mov) => {
//     if (!mov.fecha || !mov.categoriaId || !mov.total) return;

//     const mes = mov.fecha.slice(0, 7); // solo meses existentes
//     const cat = categorias.find((c) => c.id === mov.categoriaId);
//     if (!cat) return;

//     let padreId = cat.idPadre && cat.idPadre !== 0 ? cat.idPadre : cat.id;
//     const catPadre = categorias.find((c) => c.id === padreId);
//     const abueloId = catPadre?.idPadre && catPadre.idPadre !== 0 ? catPadre.idPadre : null;
//     padreId = abueloId || padreId;

//     if (!gastos[mes]) {
//       gastos[mes] = {};
//       Object.keys(subArrPadres).forEach((pid) => {
//         gastos[mes][pid] = 0;
//       });
//     }

//     gastos[mes][padreId] += Math.abs(mov.total);
//   });

//   const meses = Object.keys(gastos).sort();

//   // Transformar datos para Recharts
//   const chartData = meses.map((mes) => {
//     const row = { mes };
//     visibleCategories.forEach((catId) => {
//       if (gastos[mes][catId] !== undefined) {
//         row[subArrPadres[catId].categoria] = gastos[mes][catId];
//       }
//     });
//     return row;
//   });

//   const toggleCategory = (catId) => {
//     setVisibleCategories((prev) =>
//       prev.includes(catId) ? prev.filter((id) => id !== catId) : [...prev, catId]
//     );
//   };

//   return (
//     <div className="comparativa-chart-container">
//       <div className="checkboxes">
//         {Object.entries(subArrPadres).map(([catId, cat], idx) => (
//           <label key={catId} style={{ color: colors[idx % colors.length], marginRight: 10 }}>
//             <input
//               type="checkbox"
//               checked={visibleCategories.includes(catId)}
//               onChange={() => toggleCategory(catId)}
//             />
//             {cat.categoria}
//           </label>
//         ))}
//       </div>

//       <ResponsiveContainer width="100%" height={400}>
//         <LineChart data={chartData} margin={{ top: 20, right: 30, bottom: 20, left: 0 }}>
//           <CartesianGrid strokeDasharray="3 3" />
//           <XAxis dataKey="mes" />
//           <YAxis />
//           <Tooltip />
//           <Legend />
//           {Object.entries(subArrPadres).map(([catId, cat], idx) =>
//             visibleCategories.includes(catId) ? (
//               <Line
//                 key={catId}
//                 type="linear" // línea recta
//                 dataKey={cat.categoria}
//                 stroke={colors[idx % colors.length]}
//                 dot={{ r: 4 }}
//                 activeDot={{ r: 6 }}
//               />
//             ) : null
//           )}
//         </LineChart>
//       </ResponsiveContainer>
//     </div>
//   );
// };

// export default ComparativaTotalesChart;
// src/reports/ComparativaTotalesChart.js





// import React, { useState } from "react";
// import {
//   LineChart,
//   Line,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   Legend,
//   ResponsiveContainer,
// } from "recharts";
// import "./ComparativaTotales.css";

// const colors = [
//   "#8884d8",
//   "#82ca9d",
//   "#ff7300",
//   "#ff0000",
//   "#0088FE",
//   "#00C49F",
//   "#FFBB28",
//   "#FF8042",
// ];

// const ComparativaTotalesChart = ({ data }) => {
//   // --- Hook inicializado siempre ---
//   const [visibleCategories, setVisibleCategories] = useState([]);

//   if (!data || !data.movimientos || !data.categorias || !data.presupuestos) {
//     return <p>No hay datos suficientes para mostrar la gráfica.</p>;
//   }

//   const { movimientos, categorias } = data;

//   // --- Crear mapa de categorías padre ---
//   const subArrPadres = {};
//   categorias
//     .filter((cat) => !cat.idPadre)
//     .forEach((cat) => {
//       subArrPadres[cat.id] = { categoria: cat.nombre };
//     });

//   // --- Inicializar visibleCategories solo la primera vez ---
//   if (visibleCategories.length === 0) {
//     setVisibleCategories(Object.keys(subArrPadres));
//   }

//   // --- Agrupar movimientos por mes y categoría padre ---
//   const gastos = {};
//   movimientos.forEach((mov) => {
//     if (!mov.fecha || !mov.categoriaId || !mov.total) return;

//     const mes = mov.fecha.slice(0, 7); // YYYY-MM
//     const cat = categorias.find((c) => c.id === mov.categoriaId);
//     if (!cat) return;

//     let padreId = cat.idPadre && cat.idPadre !== 0 ? cat.idPadre : cat.id;
//     const catPadre = categorias.find((c) => c.id === padreId);
//     const abueloId = catPadre?.idPadre && catPadre.idPadre !== 0 ? catPadre.idPadre : null;
//     padreId = abueloId || padreId;

//     if (!gastos[mes]) {
//       gastos[mes] = {};
//       Object.keys(subArrPadres).forEach((pid) => {
//         gastos[mes][pid] = 0;
//       });
//     }

//     gastos[mes][padreId] += Math.abs(mov.total);
//   });

//   const meses = Object.keys(gastos).sort();

//   // Transformar datos para Recharts
//   const chartData = meses.map((mes) => {
//     const row = { mes };
//     Object.keys(subArrPadres).forEach((catId) => {
//       row[subArrPadres[catId].categoria] = gastos[mes][catId];
//     });
//     return row;
//   });

//   const toggleCategory = (catId) => {
//     setVisibleCategories((prev) =>
//       prev.includes(catId)
//         ? prev.filter((id) => id !== catId)
//         : [...prev, catId]
//     );
//   };

//   const showAll = () => setVisibleCategories(Object.keys(subArrPadres));
//   const hideAll = () => setVisibleCategories([]);

//   return (
//     <div className="comparativa-chart-container">
//       <div className="badges-container" style={{ marginBottom: 10 }}>
//         <button onClick={showAll} style={{ marginRight: 10 }}>Mostrar todos</button>
//         <button onClick={hideAll}>Ocultar todos</button>
//       </div>
//       <div className="badges-container" style={{ marginBottom: 20 }}>
//         {Object.entries(subArrPadres).map(([catId, cat], idx) => {
//           const isVisible = visibleCategories.includes(catId);
//           return (
//             <span
//               key={catId}
//               onClick={() => toggleCategory(catId)}
//               style={{
//                 cursor: "pointer",
//                 display: "inline-block",
//                 padding: "5px 10px",
//                 marginRight: 5,
//                 marginBottom: 5,
//                 borderRadius: 12,
//                 backgroundColor: isVisible
//                   ? colors[idx % colors.length]
//                   : colors[idx % colors.length] + "55",
//                 color: "white",
//                 fontWeight: "bold",
//                 fontSize: 12,
//               }}
//             >
//               {cat.categoria}
//             </span>
//           );
//         })}
//       </div>

//       <ResponsiveContainer width="100%" height={400}>
//         <LineChart data={chartData} margin={{ top: 20, right: 30, bottom: 20, left: 0 }}>
//           <CartesianGrid strokeDasharray="3 3" />
//           <XAxis dataKey="mes" />
//           <YAxis />
//           <Tooltip />
//           <Legend />
//           {Object.entries(subArrPadres).map(([catId, cat], idx) =>
//             visibleCategories.includes(catId) ? (
//               <Line
//                 key={catId}
//                 type="linear"
//                 dataKey={cat.categoria}
//                 stroke={colors[idx % colors.length]}
//                 dot={{ r: 4 }}
//                 activeDot={{ r: 6 }}
//               />
//             ) : null
//           )}
//         </LineChart>
//       </ResponsiveContainer>
//     </div>
//   );
// };

// export default ComparativaTotalesChart;


// src/reports/ComparativaTotalesChart.js
import React, { useState } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import "./ComparativaTotales.css";

const colors = [
  "#8884d8",
  "#82ca9d",
  "#ff7300",
  "#ff0000",
  "#0088FE",
  "#00C49F",
  "#FFBB28",
  "#FF8042",
];

const ComparativaTotalesChart = ({ data }) => {
  // --- Crear mapa de categorías padre ---
  const subArrPadres = {};
  (data?.categorias || [])
    .filter((cat) => !cat.idPadre)
    .forEach((cat) => {
      subArrPadres[cat.id] = { categoria: cat.nombre };
    });

  // --- Hook inicializado siempre ---
  const [visibleCategories, setVisibleCategories] = useState(Object.keys(subArrPadres));

  // Comprobar si los datos están disponibles
  if (!data || !data.movimientos || !data.categorias || !data.presupuestos) {
    return <p>No hay datos suficientes para mostrar la gráfica.</p>;
  }

  const { movimientos, categorias } = data;

  // --- Agrupar movimientos por mes y categoría padre ---
  const gastos = {};
  movimientos.forEach((mov) => {
    if (!mov.fecha || !mov.categoriaId || !mov.total) return;

    const mes = mov.fecha.slice(0, 7); // YYYY-MM
    const cat = categorias.find((c) => c.id === mov.categoriaId);
    if (!cat) return;

    let padreId = cat.idPadre && cat.idPadre !== 0 ? cat.idPadre : cat.id;
    const catPadre = categorias.find((c) => c.id === padreId);
    const abueloId = catPadre?.idPadre && catPadre.idPadre !== 0 ? catPadre.idPadre : null;
    padreId = abueloId || padreId;

    if (!gastos[mes]) {
      gastos[mes] = {};
      Object.keys(subArrPadres).forEach((pid) => {
        gastos[mes][pid] = 0;
      });
    }

    gastos[mes][padreId] += Math.abs(mov.total);
  });

  const meses = Object.keys(gastos).sort();

  // Transformar datos para Recharts
  const chartData = meses.map((mes) => {
    const row = { mes };
    Object.keys(subArrPadres).forEach((catId) => {
      row[subArrPadres[catId].categoria] = gastos[mes][catId];
    });
    return row;
  });

  const toggleCategory = (catId) => {
    setVisibleCategories((prev) =>
      prev.includes(catId)
        ? prev.filter((id) => id !== catId)
        : [...prev, catId]
    );
  };

  const showAll = () => setVisibleCategories(Object.keys(subArrPadres));
  const hideAll = () => setVisibleCategories([]);

  return (
    <div className="comparativa-chart-container">
      <div className="badges-container" style={{ marginBottom: 10 }}>
        <button onClick={showAll} style={{ marginRight: 10 }}>Mostrar todos</button>
        <button onClick={hideAll}>Ocultar todos</button>
      </div>
      <div className="badges-container" style={{ marginBottom: 20 }}>
        {Object.entries(subArrPadres).map(([catId, cat], idx) => {
          const isVisible = visibleCategories.includes(catId);
          return (
            <span
              key={catId}
              onClick={() => toggleCategory(catId)}
              style={{
                cursor: "pointer",
                display: "inline-block",
                padding: "5px 10px",
                marginRight: 5,
                marginBottom: 5,
                borderRadius: 12,
                backgroundColor: isVisible
                  ? colors[idx % colors.length]
                  : colors[idx % colors.length] + "55",
                color: "white",
                fontWeight: "bold",
                fontSize: 12,
              }}
            >
              {cat.categoria}
            </span>
          );
        })}
      </div>

      <ResponsiveContainer width="100%" height={400}>
        <LineChart data={chartData} margin={{ top: 20, right: 30, bottom: 20, left: 0 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="mes" />
          <YAxis />
          <Tooltip />
          <Legend />
          {Object.entries(subArrPadres).map(([catId, cat], idx) =>
            visibleCategories.includes(catId) ? (
              <Line
                key={catId}
                type="linear"
                dataKey={cat.categoria}
                stroke={colors[idx % colors.length]}
                dot={{ r: 4 }}
                activeDot={{ r: 6 }}
              />
            ) : null
          )}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ComparativaTotalesChart;
